import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RecipientMaintenanceRoutingModule } from './recipient-maintenance-routing.module';
import { RecipientMaintenanceComponent } from './recipient-maintenance.component';
import { RecipientMaintenanceFormComponent } from './recipient-maintenance-form/recipient-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { RecipientMaintenanceFilterComponent } from './recipient-maintenance-filter/recipient-maintenance-filter.component';
import { BranchDropdownModule } from 'src/app/core/custom-modules/dropdowns/branch-dropdown/branch-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    RecipientMaintenanceRoutingModule,
    BranchDropdownModule
  ],
  declarations: [RecipientMaintenanceComponent, RecipientMaintenanceFormComponent, RecipientMaintenanceFilterComponent],
  entryComponents: [RecipientMaintenanceFilterComponent]
})
export class RecipientMaintenanceModule { }
